import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import { IgxToastComponent } from '@infragistics/igniteui-angular/toast';
import { VerticalAlignment } from '@infragistics/igniteui-angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {ToggleViewEventArgs} from "@infragistics/igniteui-angular";

@Component({
  selector: 'app-toas-neo',
  templateUrl: './toas-neo.component.html',
  styleUrls: ['./toas-neo.component.scss'],
  imports: [
    IgxToastComponent,
    TranslateModule
  ]
})
export class ToasNeoComponent implements OnInit {
  @ViewChild('toast', {static: true})
  public toastNeo: IgxToastComponent;

  @Output() evtCerrado = new EventEmitter<void>();

  public toastMensaje: string;
  public toastTiempo: number;
  public autoHide: boolean;

  constructor() {
  }

  ngOnInit(): void {
  }

  /**
   * @param mensaje = texto a mostrar
   * @param tiempo =  por default 1000
   * @param autoHide = por default false
   * @param posicion = por default bottom, puede cambiarlo: top, middle
   */
  public abrir(mensaje: string, tiempo: number, autoHide: boolean, posicion: VerticalAlignment) {
    this.toastMensaje = mensaje;
    if (!autoHide) {
      this.toastNeo.autoHide = autoHide;
    } else {
      this.toastNeo.displayTime = tiempo;
    }
    this.toastNeo.positionSettings.verticalDirection = posicion;
    this.toastNeo.open();
  }

  public onChange(evt: ToggleViewEventArgs) {
    if (!evt.owner.isVisible) {
      this.evtCerrado.emit();
    }
  }
}
